import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'promocode-modal',
  styleUrls: ['./promocode-modal.component.scss'],
  templateUrl: './promocode-modal.component.html',
})
export class PromocodeModalComponent {

  @Input() error;
  @Output() apply = new EventEmitter();
  @Output() hide = new EventEmitter();

  promocode = '';

  close() {
    this.hide.emit();
  }

  onSubmit() {
    this.apply.emit(this.promocode);
  }
}
